// import Confirm from "@/../../coreui/library/Confirm"
export default {
  data: () => ({
    noServerAccess: false
  }),
  methods: {
    setOnline () {
      this.$toasted.clear()
      this.$toasted.show('Network is now connected', {type: 'success'})
      this.noServerAccess = false
    },
    setOffline () {
      this.$toasted.show('Network disconnected', {type: 'error', duration: 900 * 1000})
      this.noServerAccess = true
    }
  },
  mounted () {
    if (this.noServerAccess) {
      this.$toasted.show('Server is not accessible, please try again later', {type: 'error', duration: 900 * 1000})
    } else {
      this.$toasted.clear()
    }
  }
}